// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/transportation/flight_search.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/feature/transportation/flight_search.proto.
 */
export const file_proto_model_feature_transportation_flight_search = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message carmen.FlightSearchCriteria.
 * Use `create(FlightSearchCriteriaSchema)` to create a new message.
 */
export const FlightSearchCriteriaSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight_search, 0);

/**
 * Describes the message carmen.FlightSearchCriteria.AdditionalInformation.
 * Use `create(FlightSearchCriteria_AdditionalInformationSchema)` to create a new message.
 */
export const FlightSearchCriteria_AdditionalInformationSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight_search, 0, 0);

/**
 * Describes the message carmen.FlightSearchCriteria.PricingOptions.
 * Use `create(FlightSearchCriteria_PricingOptionsSchema)` to create a new message.
 */
export const FlightSearchCriteria_PricingOptionsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight_search, 0, 1);

/**
 * Describes the message carmen.FlightSearchCriteria.FlightFilters.
 * Use `create(FlightSearchCriteria_FlightFiltersSchema)` to create a new message.
 */
export const FlightSearchCriteria_FlightFiltersSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight_search, 0, 2);

/**
 * Describes the message carmen.FlightSearchCriteria.CarrierRestrictions.
 * Use `create(FlightSearchCriteria_CarrierRestrictionsSchema)` to create a new message.
 */
export const FlightSearchCriteria_CarrierRestrictionsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight_search, 0, 3);

/**
 * Describes the message carmen.FlightSearchCriteria.CabinRestriction.
 * Use `create(FlightSearchCriteria_CabinRestrictionSchema)` to create a new message.
 */
export const FlightSearchCriteria_CabinRestrictionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight_search, 0, 4);

/**
 * Describes the message carmen.FlightSearchCriteria.ConnectionRestriction.
 * Use `create(FlightSearchCriteria_ConnectionRestrictionSchema)` to create a new message.
 */
export const FlightSearchCriteria_ConnectionRestrictionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight_search, 0, 5);

/**
 * Describes the enum carmen.FlightSearchCriteria.TravelClass.
 */
export const FlightSearchCriteria_TravelClassSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_transportation_flight_search, 0, 0);

/**
 * Travel class enum
 *
 * @generated from enum carmen.FlightSearchCriteria.TravelClass
 */
export const FlightSearchCriteria_TravelClass = /*@__PURE__*/
  tsEnum(FlightSearchCriteria_TravelClassSchema);

/**
 * Describes the enum carmen.FlightSearchCriteria.Coverage.
 */
export const FlightSearchCriteria_CoverageSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_transportation_flight_search, 0, 1);

/**
 * Coverage enum
 *
 * @generated from enum carmen.FlightSearchCriteria.Coverage
 */
export const FlightSearchCriteria_Coverage = /*@__PURE__*/
  tsEnum(FlightSearchCriteria_CoverageSchema);

